import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["indicator", "menu", "option"]
  static values = { theme: { type: String, default: "auto" } }

  connect() {
    const saved = localStorage.getItem("theme")
    this.themeValue = saved || "auto"
    this.applyTheme()
    this.watchSystem()
    document.addEventListener("turbo:load", this._boundReapply ||= this.applyTheme.bind(this))
  }

  disconnect() {
    this.unwatchSystem()
    document.removeEventListener("turbo:load", this._boundReapply)
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  select(event) {
    this.themeValue = event.currentTarget.dataset.value
    localStorage.setItem("theme", this.themeValue)
    this.applyTheme()
    this.menuTarget.classList.add("hidden")
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  applyTheme() {
    const isDark = this.themeValue === "dark" ||
      (this.themeValue === "auto" && window.matchMedia("(prefers-color-scheme: dark)").matches)

    document.documentElement.classList.toggle("dark", isDark)

    if (this.hasIndicatorTarget) {
      this.indicatorTarget.className = this.iconClass
    }

    this.optionTargets.forEach(el => {
      el.classList.toggle("bg-emerald-700/40", el.dataset.value === this.themeValue)
    })
  }

  watchSystem() {
    this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    this.boundListener = () => {
      if (this.themeValue === "auto") this.applyTheme()
    }
    this.mediaQuery.addEventListener("change", this.boundListener)
  }

  unwatchSystem() {
    if (this.mediaQuery && this.boundListener) {
      this.mediaQuery.removeEventListener("change", this.boundListener)
    }
  }

  get iconClass() {
    if (this.themeValue === "light") return "fa-solid fa-sun"
    if (this.themeValue === "dark") return "fa-solid fa-moon"
    return "fa-solid fa-circle-half-stroke"
  }

  get label() {
    if (this.themeValue === "light") return "Claro"
    if (this.themeValue === "dark") return "Escuro"
    return "Automático"
  }
}
